document.querySelector('.header-wrapper-inner__search-trigger').addEventListener('click', function(){
    this.closest('.header-wrapper-inner__search').classList.toggle('search--opened');
});

document.querySelector('.mobile-navigation__burger').addEventListener('click', function(){
    this.closest('.mobile-navigation-wrapper').classList.toggle('mobile-navigation-wrapper--closed');
    document.body.classList.toggle('overflow-hidden');
    document.querySelector('html').classList.toggle('overflow-hidden');
});

window.onscroll = function() {myFunction()};

let header = document.querySelector(".main-header-wrapper");
let sticky = header.offsetTop;

function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
    document.querySelector('main').classList.add('sticky-head');
  } else {
    header.classList.remove("sticky");
    document.querySelector('main').classList.remove('sticky-head');
  }
}